import axiosInstance from "./service-instance";
import {
    CONTENT_TYPES
    // CASE_TYPES
} from "constants";


export default {
    getScoreCard: (case_id, scorecard_type) =>
        axiosInstance.get(
            "/case/" + case_id + "/scorecard/" + scorecard_type + "/",
            {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        ),
    generateScoreCard: (case_id, scorecard_type) =>
        axiosInstance.post(
            "/case/scorecard/generate/",
            {
                case: case_id,
                scorecard_type
            },
            {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        )
};
